import * as React from 'react';

import { OmViewGridLess } from '@xing-com/platform-layout-om';
import { motionTimeNumberS } from '@xing-com/tokens';

import { useWrapRedirectLoggedOutUserOnClick } from '../../hooks';
import { useShortNumber } from '../../utils';
import { LazyLikersList } from '../lazy-likers-list/lazy-likers-list';

import { Styled } from './like-counter.style';

export type LikeCounterProps = {
  counter: number;
  urn: string;
  propChannel?: string;
  socialBarHasCounters?: boolean;
};

export type LikeCounterTriggerProps = {
  counter: number;
  onClick: () => void;
  socialBarHasCounters: boolean;
};

export const LikeCounter: React.FC<LikeCounterProps> = ({
  counter,
  urn,
  propChannel = '',
  socialBarHasCounters = false,
}) => (
  <OmViewGridLess
    trigger={(onClick) => (
      <LikeCounterTrigger {...{ onClick, counter, socialBarHasCounters }} />
    )}
  >
    <LazyLikersList {...{ urn, propChannel, first: 20 }} />
  </OmViewGridLess>
);

export const LikeCounterTrigger: React.FC<LikeCounterTriggerProps> = ({
  onClick,
  counter,
  socialBarHasCounters,
}) => {
  const { handleClick } = useWrapRedirectLoggedOutUserOnClick(onClick);
  const { shortNumber } = useShortNumber(counter);
  const [likeCounter, setLikeCounter] = React.useState(shortNumber);
  const [isDisplayed, setIsDisplayed] = React.useState(false);

  React.useEffect(() => {
    if (counter) {
      setLikeCounter(shortNumber);
      setIsDisplayed(true);
    } else if (counter === 0) {
      // TODO: like counter animation
      if (socialBarHasCounters) {
        setIsDisplayed(false);
      } else {
        setTimeout(() => {
          setIsDisplayed(false);
        }, parseInt(motionTimeNumberS));
      }
    }
  }, [socialBarHasCounters, counter, shortNumber]);

  return isDisplayed ? (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    <Styled.LikeButton fontWeight="regular" onClick={handleClick} size="small">
      <React.Fragment>
        <Styled.LikeBadge />
        <Styled.LikeCounter data-qa="like-counter">
          {likeCounter}
        </Styled.LikeCounter>
      </React.Fragment>
    </Styled.LikeButton>
  ) : null;
};
